<template>
  <div>
    <el-row style="margin-bottom:10px;" v-if="!isDetail">
      <el-col :span="$store.state.isMB ? 8 : 4">
        <el-upload :headers="{ Authorization: 'Bearer ' + token }" :action="uploadUrl" :on-progress="uploadProcess" accept=".mp3"
          :on-success="handleSuccess" :before-upload="beforeUpload" :show-file-list="false">
          <el-button type="primary" style="vertical-align:10px;" @click="onClick">添加附件</el-button>
        </el-upload>
      </el-col>
      <el-col :span="$store.state.isMB ? 16 : 20">
        <el-progress v-show="showProgress" style="margin-top:6px;" :percentage="uploadPercent"></el-progress>
      </el-col>
    </el-row>
    <el-row v-loading="isLoading" v-for="(i, key) in fileList" :key="key" class="upload-item">
      <el-col :span="1">
        <i class="el-icon-document" style="margin-left:10px;"></i>
      </el-col>
      <el-col :span="19">
        <span>{{ i.FileName }}.{{ i.Extension }}</span>
      </el-col>
      <el-col :span="4" style="color:#409EFF">
        <i class="el-icon-download" style="cursor: pointer" @click="download(i)"></i>
        <el-popconfirm title="确定删除吗？" confirmButtonType="text" @confirm="onDelete(i.AttachmentId, key)"
          style="margin-left:15px">
          <i slot="reference" v-if="!isDetail" class="el-icon-delete" style="cursor: pointer"></i>
        </el-popconfirm>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import api from "@/api/common/common";
export default {
  props: {
    fileList: {
      type: Array,
      default: () => [],
    },
    isDetail: {
      type: Boolean,
      default: false,
    },
    uploadUrl: {
      type: String,
      default: "/api" + api.uploadFile,
    },
    deleteFunc: {
      type: Function,
      default: api.delete,
    },
    //为 true 的时候需要提供删除接口 deleteFunc 
    hardDelete: {
      type: Boolean,
      default: false,
    },
    //文件大小，默认不超过5MB
    limit: {
      type: Number,
      default: 5,
    },
    limitNum: {
      type: Number,
      default: 0,
    },
    keyName: {
      type: String,
      default: "VirtualPath",
    },
  },
  data() {
    return {
      isLoading: false,
      token: localStorage.getItem("token"),

      showProgress: false, //显示进度条
      uploadPercent: 0, //进度条的进度
    };
  },
  computed: {},
  methods: {
    onClick() {
      console.log("get_new_token");
      this.token = localStorage.getItem("token");
    },
    download(item) {
      const elink = document.createElement("a");
      elink.download = item.FileName;
      elink.style.display = "none";
      elink.target = "_blank";
      elink.href = location.origin + "/api" + item.FileUrl;
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    },
    //上传前回调
    beforeUpload(file) {
      if(this.limitNum>0&&this.fileList.length==this.limitNum) {
        this.$message.warning("最多只能上传" + this.limitNum + "个文件");
        return false;
      }
      // var config = this.$store.state.user.fileConfig;
      // var limit = config.AttachLimit;
      // console.log("limit", limit);

      var limit = this.limit; //文件大小限制
      // console.log("size", file.size, file.size / 1024 / 1024);
      if (file.size / 1024 / 1024 > limit) {
        this.$message.warning("附件大小不能大于" + limit + "MB");
        return false;
      }

      this.showProgress = true;
    },
    //进度条
    uploadProcess(event, file, fileList) {
      this.uploadPercent = file.percentage.toFixed(0) * 1;
    },
    //上传成功回调
    handleSuccess(res, file) {
      if (res.Code == 1) {
        this.$message.error(res.Msg);
      } else {
        this.$emit("success", res);
      }

      this.showProgress = false;
      this.uploadPercent = 0;
    },
    onDelete(id, index) {
      console.log("删除附件", id, index);
      if (this.hardDelete) {
        this.isLoading = true;
        this.deleteFunc({ id }).then((res) => {
          this.isLoading = false;
          if (res.Code == 0) {
            this.$emit("delete", index);
          } else {
            this.$message.error(res.Msg);
          }
        });
      } else {
        this.$emit("delete", index);
      }
    },
  },
};
</script>

<style lang="scss">
.upload-item {
  height: 30px;
  line-height: 30px;
}
</style>